import { API } from "../../../api/api";
import { HistoryAPIRoutes } from "./apiRoutes";

const getActivityLogs = ({ skip, top, event, users, range, entity_type, entity_id }) => {
    let parameters = [];
    /*Object.keys(search).map(key => {
        if (key == "subsidiary" && search[key].length > 0)
            parameters.push(`subsidiary in ${search[key]}`);
        else if (key == "gameEngine" && search[key].length > 0)
            parameters.push(`engine_version_id in ${search[key]}`);
        else if (key == "status" && search[key].length > 0)
            parameters.push(`active eq ${search[key]}`);
    });*/
    parameters.push(`event_log_type_id eq 2`)
    if (event && event.length > 0) parameters.push(`action eq '${event}'`);
    if (users && users.length > 0) parameters.push(`event_user_id in (${users
        .map(c => c)
        .join(",")},)`);
    if (entity_type && entity_type.length > 0) parameters.push(`entity_type eq '${entity_type}'`);
    if (entity_id) parameters.push(`entity_id in (${entity_id},)`);
    if (range) {
        if (range.start && range.start.length > 0)
            parameters.push(`event_time ge '${range.start}'`);
        if (range.end && range.end.length > 0)
            parameters.push(`event_time le '${range.end}'`);
    }

    let filter = parameters.join(" and ");
    return API.request({
        routeID: HistoryAPIRoutes.GET_ACTIVITY_LOGS,
        odataParameters: {
            skip,
            top,
            filter: filter,
            orderby: "-id"
        }
    });
};

const getHistoryUsers = ({ skip, top, search }) => {
    let parameters = [];
    parameters.push(`account_status_id eq 1`);

    let filter = parameters.join(" and ");
    return API.request({
        routeID: HistoryAPIRoutes.GET_HISTORY_USERS,
        odataParameters: {
            skip,
            top,
            filter: filter,
            search: search,
            orderby: "-id"
        }
    });
};

const getHistoryUsersById = ({ ids }: { ids: number[] }) => {
    return API.request({
        routeID: HistoryAPIRoutes.GET_HISTORY_USERS,
        odataParameters: {
            skip: 0,
            top: 1000000,
            ...(ids.length && { filter:`id in (${ids},)`}),
            orderby: "-id"
        }
    });
};

export const historyAPI = {
    getActivityLogs,
    getHistoryUsers,
    getHistoryUsersById
};
